<div>
  <div class="content-wrapper" *ngrxLet="trendingData$ | async as trendingData">
    <app-banner type="info">{{
      '+INSTALLATIONS.INSTALLATION.TRENDING.REDESIGN_1' | translate
    }}</app-banner>

    <div
      class="trending-tab-wrapper"
      *ngrxLet="trendingStore.selectTrendingTabData$ as trendingTabData"
    >
      <ng-container *ngFor="let trendingTab of trendingTabData">
        <button
          *ngIf="trendingTab.isShow"
          class="trending-tab flex-1 w-[200px] py-2 font-semibold text-center rounded-md border border-gray-300 opacity-50 hover:opacity-100 transition focus:outline-none active:bg-gray-100 active:opacity-100"
          [class.active]="trendingTab.isActive"
          (click)="switchTab(trendingTab.type)"
        >
          {{ trendingTab.name }}
        </button>
      </ng-container>
      <div *ngIf="trendingStore.isAllowedToShowViUnifyButton$ | async" class="text-right flex-auto">
        <button
          data-at-assign-to-device-button
          mat-raised-button
          class="viunify_btn"
          color="primary"
          gtm="onOpen"
          gtmAction="ViUnify modal"
          gtmCategory="trending"
          (click)="openViUnifyModal()"
        >
          {{ '+INSTALLATIONS.INSTALLATION.TRENDING.VIUNIFY_BUTTON' | translate }}
        </button>
        <mat-icon
          class="info-icon align-middle ml-1"
          [matTooltip]="'+INSTALLATIONS.INSTALLATION.TRENDING.VIUNIFY_TOOLTIP' | translate"
          matTooltipPosition="above"
        >
          info_outline
        </mat-icon>
      </div>
    </div>

    <div content *ngIf="(trendingStore.state$ | async).loading" class="flex flex-col gap-[24px]">
      <div class="flex flex-col gap-[24px]">
        <vi-loader
          data-at-loader
          [isLoading]="true"
          [message]="'+GENERAL.LOADING_DATA' | translate"
        ></vi-loader>
      </div>
    </div>
    <div [hidden]="(trendingStore.state$ | async).loading">
      <div class="content-wrapper" *ngIf="trendingData; else trendingDataEmpty">
        <app-trending-date-range></app-trending-date-range>
        <ng-container [ngSwitch]="currentTab">
          <div class="content-wrapper" *ngSwitchCase="trendingType.HEATING">
            <app-trending-line-chart
              [trends]="trends.primaryTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PRIMARY_TRENDS_OVERVIEW' | translate
              }}"
            ></app-trending-line-chart>
            <app-trending-line-chart
              [trends]="trends.secondaryTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SECONDARY_TRENDS_OVERVIEW' | translate
              }}"
            ></app-trending-line-chart>
            <app-trending-line-chart
              [trends]="trends.primarySecondaryTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PRIMARY_SECONDARY_TRENDS_OVERVIEW'
                  | translate
              }}"
            ></app-trending-line-chart>
            <app-trending-line-chart
              [trends]="trends.coolingCircuitsPrimaryTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.COOLING_CIRCUIT_PRIMARY_TRENDS_OVERVIEW'
                  | translate
              }}"
            ></app-trending-line-chart>
            <app-trending-line-chart
              [trends]="trends.allTrendsCombined"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.ALL_PARAMETERS_TRENDS_OVERVIEW'
                  | translate
              }}"
            ></app-trending-line-chart>
            <app-trending-xrange-chart
              [trends]="trends.enumMappedTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.STATUS_OVERVIEW' | translate
              }}"
            ></app-trending-xrange-chart>
          </div>

          <div class="content-wrapper" *ngSwitchCase="trendingType.ENERGY_STORAGE">
            <ng-container
              *ngrxLet="trendingStore.powerTrendingChartsLabel$ as powerTrendingChartsLabel"
            >
              <app-trending-line-chart
                [trends]="powerTrendingChartsLabel"
                name="{{
                  '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.POWER_CHART_OVERVIEW' | translate
                }}"
              ></app-trending-line-chart>
            </ng-container>

            <ng-container *ngrxLet="trendingStore.stateOfChargeLabel$ as stateOfChargeLabel">
              <app-trending-line-chart
                [trends]="stateOfChargeLabel"
                name="{{
                  '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.STATE_OF_CHARGE_OVERVIEW'
                    | translate
                }}"
              ></app-trending-line-chart>
            </ng-container>
            <ng-container *ngrxLet="devicesStore.selectVitoChargeDevices$ as vitoChargeDevice">
              <ng-container
                *ngIf="installationFeaturesStore.isShowPvVoltage(vitoChargeDevice) | async"
              >
                <app-trending-line-chart
                  [trends]="trends.pvVoltageTrends"
                  name="{{
                    '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PV_VOLTAGE_OVERVIEW' | translate
                  }}"
                ></app-trending-line-chart>
              </ng-container>
            </ng-container>

            <ng-container
              *ngrxLet="trendingStore.selectTemperaturesLabel$ as selectTemperaturesLabel"
            >
              <ng-container
                *ngrxLet="devicesStore.selectBatteryModuleCategory$ as selectBatteryModuleCategory"
              >
                <app-trending-line-chart
                  [trends]="selectTemperaturesLabel"
                  [trendingCategories]="selectBatteryModuleCategory"
                  [isHasCategories]="true"
                  name="{{
                    '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.TEMPERATURES_OVERVIEW' | translate
                  }}"
                ></app-trending-line-chart>
              </ng-container>
            </ng-container>

            <ng-container
              *ngrxLet="trendingStore.selectBatteryModuleVoltageLabel$ as batteryModuleVoltageLabel"
            >
              <app-trending-line-chart
                [trends]="batteryModuleVoltageLabel"
                name="{{
                  '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.BATTERY_MODULE_VOLTAGE_OVERVIEW'
                    | translate
                }}"
              ></app-trending-line-chart>
            </ng-container>
          </div>

          <div class="content-wrapper" *ngSwitchCase="trendingType.COMMUNICATION_MODULE">
            <app-trending-line-chart
              [trends]="trends.communicationModuleWifiStrengthTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.COMMUNICATION_MODULE.WIFI_STRENGTH_OVERVIEW'
                  | translate
              }}"
            ></app-trending-line-chart>
            <app-trending-xrange-chart
              [trends]="trends.communicationModuleGatewayStatusTrends"
              name="{{
                '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.COMMUNICATION_MODULE.GATEWAY_STATUS_OVERVIEW'
                  | translate
              }}"
            ></app-trending-xrange-chart>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #trendingDataEmpty>
    <app-trending-date-range></app-trending-date-range>
    <ng-container [ngSwitch]="trendingStore.dateseriesError$ | async">
      <app-banner *ngSwitchCase="TrendingDateseriesError.NoDataWithinRange" type="warning">{{
        '+INSTALLATIONS.INSTALLATION.TRENDING.ERROR_NO_DATA_WITHIN_RANGE' | translate
      }}</app-banner>

      <app-banner *ngSwitchCase="TrendingDateseriesError.ErrorDataNotFound502" type="warning">
        {{ '+INSTALLATIONS.INSTALLATION.TRENDING.ERROR_DATA_NOT_FOUND_502' | translate }}
      </app-banner>

      <app-banner *ngSwitchCase="TrendingDateseriesError.ErrorBigDataError400" type="error">{{
        '+INSTALLATIONS.INSTALLATION.TRENDING.ERROR_BIG_DATA_ERROR_400' | translate
      }}</app-banner>

      <app-banner *ngSwitchCase="TrendingDateseriesError.ErrorConnectionTimeout504" type="error">{{
        '+INSTALLATIONS.INSTALLATION.TRENDING.ERROR_CONNECTION_TIMEOUT_504' | translate
      }}</app-banner>

      <app-banner *ngSwitchDefault type="warning">{{
        '+INSTALLATIONS.INSTALLATION.TRENDING.ERROR' | translate
      }}</app-banner>
    </ng-container>
  </ng-template>
</div>
